'use strict';

export default class Faq {
    constructor() {
        const lists = document.querySelectorAll( '[data-faq]' );

        lists.forEach( ( list ) => {
            const items = list.querySelectorAll( '[data-faq-item]' );

            items.forEach( ( item ) => {
                const trigger = item.querySelector( '[data-faq-trigger]' );
                if ( ! trigger ) return;

                trigger.addEventListener( 'click', () => {
                    const isOpen = item.classList.toggle( 'is-open' );
                    trigger.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
                } );
            } );
        } );
    }
}
